/**
 * @GENERATED from Figma node 3608:51021
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const HubspotDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#FF5C35"
      fillRule="evenodd"
      d="M3.667 2C2.747 2 2 2.746 2 3.667v16.666C2 21.253 2.746 22 3.667 22h16.666c.92 0 1.667-.746 1.667-1.667V3.667C22 2.747 21.254 2 20.333 2z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M15.812 9.439V7.653a1.38 1.38 0 0 0 .792-1.24v-.041c0-.76-.615-1.376-1.374-1.376h-.041c-.76 0-1.375.616-1.375 1.376v.04a1.38 1.38 0 0 0 .793 1.24V9.44a3.9 3.9 0 0 0-1.851.815L7.86 6.44q.053-.19.056-.386a1.55 1.55 0 0 0-2.642-1.1A1.55 1.55 0 0 0 6.364 7.6c.269-.002.532-.073.764-.208l4.82 3.754a3.91 3.91 0 0 0 .06 4.4l-1.466 1.468a1.3 1.3 0 0 0-.367-.06 1.272 1.272 0 1 0 1.273 1.274 1.3 1.3 0 0 0-.06-.366l1.451-1.452a3.91 3.91 0 0 0 4.462.215 3.915 3.915 0 0 0-1.49-7.186m-.577 5.894a2.008 2.008 0 1 0 0-4.015 2.008 2.008 0 0 0 0 4.015"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = React.forwardRef(HubspotDark);
export { ForwardRef as HubspotDark };
